import {
    GETUSERBYPARTY,
    set,
    axios,
    config,
    LOGINAUTH,
    LOGINULL,
    CREATEUSER,
    GETUSER,
    UPDATEUSER,
    GETUSERBYROLL,
    UPDATEUSERBYMOBAIL,
    DELETEUSER,
    GENERATECAPTCHA,
    GETALLUSERSFILTER,
    GETUSERDATA
} from '../actions/types';

const initialState = {
    loginData: [],
    username: null,
    status: 0
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case LOGINAUTH:
            console.log("login payload")
            console.log(action.payload)
            return {
                ...state,
                loginData: action.payload.data,
                username: action.payload.data.username,
                authToken: action.payload.data.token,
                hospitalID: action.payload.data.hospitalID,
                hospitalName: action.payload.data.hospitalName,
                hospitalLargeLogo: action.payload.data.hospitalLargeLogo,
                profileimage: action.payload.data.profileimage,
                Staffid: action.payload.data.partytypeId,
                UserID: action.payload.data.id,
                partytype: action.payload.data.partytype,
                StaffRole: action.payload.data.role,
                role: action.payload.data.role,
                module: action.payload.data.module_names,
                Childrenmodule: action.payload.data.Childrenmodule_names,
                app_status: action.payload.data.app_status,

            }
        case LOGINULL:
            console.log(action.payload)
            return {
                ...state,
                status: action.payload,
                authToken: undefined
            }
        case GENERATECAPTCHA:
            return {
                ...state,
                GeneratedCaptchList: action.payload.data
            }
        case CREATEUSER:
            return {
                ...state,
                userSaveStatus: action.payload.success,
                userUpdateStatus: 0,
            }
        case GETUSER:
            return {
                ...state,
                userGetData: action.payload.data
            }
        case GETUSERBYROLL:
            return {
                ...state,
                userGetByRollData: action.payload.data
            }
        case GETUSERBYPARTY:
            return {
                ...state,
                UserByPartTypeGetData: action.payload.data
            }
        case UPDATEUSER:
            return {
                ...state,
                userGetData: action.payload.data
            }
        case UPDATEUSERBYMOBAIL:
            return {
                ...state,
                userUpdateData: action.payload.data
            }
        case GETALLUSERSFILTER:
            return {
                ...state,
                filteredUsersData: action.payload.data
            }
             case GETUSERDATA:
            return {
                ...state,
                userdataList: action.payload.data
            }
        case DELETEUSER:
            return {
                ...state,
                userDeleteStatus: action.payload.data
            }
        default:
            return state
    }
}